import { jsx as _jsx } from "react/jsx-runtime";
import './QColorPicker_BackgroundForeground.scss';
import { _className, getElementCenterPos, LL_H_T, ModuleFE_MouseInteractivity, TS_Tabs } from '@nu-art/thunderstorm-frontend/index';
import React from 'react';
/**
 * A React shared-components that generates a tool for picking foreground and background colors
 * @param props - Component props
 */
export function QColorPicker_BackgroundForeground(props) {
    const pickerRef = React.createRef();
    const previewStyle = {
        background: `linear-gradient(135deg,
			 ${props.backgroundColor} 0%,
			  ${props.backgroundColor} 49%,
			   ${props.foregroundColor} 49%,
			    ${props.foregroundColor} 100%)`
    };
    const backgroundPalette = props.backgroundColors || ['#000000', '#9651E5', '#009EDA', '#7A7878', '#EE67AF', '#CF9E44', '#56A199'];
    const foregroundPalette = props.colors || ['#000000', '#FFFFFF'];
    const getPopUpLogic = () => {
        return {
            onClick: (e) => {
                const model = {
                    id: 'color-picker-pop-up',
                    content: _jsx("div", { className: 'colors-picker', ref: pickerRef, children: _jsx(TS_Tabs, { tabs: tabs }) }),
                    originPos: getElementCenterPos(e.currentTarget),
                    modalPos: { x: 0, y: 1.2 },
                    overlayClass: 'transparent'
                };
                if (!props.disabled)
                    ModuleFE_MouseInteractivity.showContent(model);
            },
        };
    };
    const tabs = [
        {
            uid: 'background',
            title: 'Background',
            content: () => {
                return _jsx(LL_H_T, { className: 'colors-container', children: backgroundPalette.map((color, i) => {
                        const className = _className('color-preview');
                        return _jsx("div", { style: { background: color }, className: className, onClick: () => props.onBackgroundChange(color) }, i);
                    }) });
            }
        },
        {
            uid: 'foreground',
            title: 'Foreground',
            content: () => {
                return _jsx(LL_H_T, { className: 'colors-container', children: foregroundPalette.map(color => {
                        const className = _className('color-preview');
                        return _jsx("div", { style: { background: color }, className: className, onClick: () => props.onForegroundChange(color) }, color);
                    }) });
            }
        }
    ];
    return _jsx("div", { className: 'q-color-picker-background-foreground', children: _jsx("div", { className: 'colors-preview', style: previewStyle, ...getPopUpLogic() }) });
}
//# sourceMappingURL=QColorPicker_BackgroundForeground.js.map